import React from 'react';
import { Link } from 'react-router-dom';

const AVAILABLE_TOOLS = [
  {
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
        <line x1="3" y1="9" x2="21" y2="9"></line>
        <line x1="3" y1="15" x2="21" y2="15"></line>
        <line x1="9" y1="3" x2="9" y2="21"></line>
        <line x1="15" y1="3" x2="15" y2="21"></line>
      </svg>
    ),
    label: 'Disponible ahora',
    title: 'Modelo de Negocios',
    description: 'Construye tu modelo de negocio completo usando los 9 bloques del Business Model Canvas con sugerencias IA en tiempo real y genera tu Plan de Acción.',
    tag: 'Business Model Canvas',
    to: '/plans/',
    cta: 'Abrir herramienta',
  },
  {
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path>
        <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>
      </svg>
    ),
    label: 'Disponible ahora',
    title: 'Plataforma Educativa',
    description: 'Accede a cursos asincrónicos organizados por ruta: empleabilidad, emprendimiento y crecimiento empresarial. Aprende a tu propio ritmo.',
    tag: 'Formación',
    href: 'https://comunidad.wirkconsulting.com/',
    cta: 'Explorar cursos',
  },
];

const COMING_SOON = [
  {
    icon: '🔬',
    title: 'Validación de Hipótesis PMV',
    description: 'Define y valida las hipótesis clave de tu Producto Mínimo Viable con metodología Lean Startup asistida por IA.',
    tag: 'Emprendimiento',
  },
  {
    icon: '🔍',
    title: 'Identificación de Oportunidades',
    description: 'Genera tu mapa de oportunidades de negocio analizando el mercado, tendencias y necesidades del entorno con inteligencia artificial.',
    tag: 'Emprendimiento',
  },
  {
    icon: '⚡',
    title: 'Pitch Profesional',
    description: 'Construye un pitch de 5 minutos con un wizard IA estructurado por secciones. Presenta tu empresa con claridad y poder de convicción.',
    tag: 'Presentación',
  },
  {
    icon: '🤖',
    title: 'Mentor IA 24/7',
    description: 'Recibe orientación personalizada en cualquier momento, con recomendaciones ajustadas a tu perfil y objetivos de emprendimiento o empleabilidad.',
    tag: 'Mentoría',
  },
  {
    icon: '🛡️',
    title: 'Perfil Profesional Digital',
    description: 'Identifica tus fortalezas, habilidades y competencias clave para potenciar tu empleabilidad con recomendaciones personalizadas por IA.',
    tag: 'Empleabilidad',
  },
];

const ConstructionContent = () => {
  return (
    <>
      <h1 className="uc__title">
        Esta función estará disponible pronto
      </h1>
      <p className="uc__subtitle">
        Estamos desarrollando los asistentes IA de <strong>Productividad 360°</strong> para acompañarte en tu ruta de emprendimiento, empleabilidad y crecimiento empresarial.
      </p>

      {/* Herramientas disponibles ahora */}
      <section className="uc__section">
        <h2 className="uc__section-title">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="20 6 9 17 4 12"></polyline>
          </svg>
          Ya puedes usar ahora
        </h2>
        <div className="uc__available-grid">
          {AVAILABLE_TOOLS.map((tool) => (
            <div key={tool.title} className="uc__available-card">
              <div className="uc__available-card-header">
                <div className="uc__available-icon">{tool.icon}</div>
                <span className="uc__available-badge">{tool.label}</span>
              </div>
              <span className="uc__available-tag">{tool.tag}</span>
              <h3 className="uc__available-title">{tool.title}</h3>
              <p className="uc__available-desc">{tool.description}</p>
              {tool.to ? (
                <Link to={tool.to} className="uc__available-cta">
                  {tool.cta}
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="5" y1="12" x2="19" y2="12"></line>
                    <polyline points="12 5 19 12 12 19"></polyline>
                  </svg>
                </Link>
              ) : (
                <a href={tool.href} target="_blank" rel="noopener noreferrer" className="uc__available-cta">
                  {tool.cta}
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="5" y1="12" x2="19" y2="12"></line>
                    <polyline points="12 5 19 12 12 19"></polyline>
                  </svg>
                </a>
              )}
            </div>
          ))}
        </div>
      </section>

      {/* Próximamente */}
      <section className="uc__section">
        <h2 className="uc__section-title">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <polyline points="12 6 12 12 16 14"></polyline>
          </svg>
          Próximamente en Productividad 360°
        </h2>
        <div className="uc__coming-grid">
          {COMING_SOON.map((item) => (
            <div key={item.title} className="uc__coming-card">
              <div className="uc__coming-card-top">
                <span className="uc__coming-icon">{item.icon}</span>
                <span className="uc__coming-tag">{item.tag}</span>
              </div>
              <h3 className="uc__coming-title">{item.title}</h3>
              <p className="uc__coming-desc">{item.description}</p>
              <div className="uc__coming-status">
                <span className="uc__coming-dot"></span>
                En desarrollo
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Caja informativa plataforma */}
      <div className="uc__info-box">
        <div className="uc__info-box-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="12"></line>
            <line x1="12" y1="16" x2="12.01" y2="16"></line>
          </svg>
        </div>
        <div className="uc__info-box-content">
          <h3>¿Qué es Productividad 360°?</h3>
          <p>
            Una plataforma integral de ICETEX que reúne <strong>formación asincrónica</strong>, <strong>asistentes IA especializados</strong> y un <strong>mentor IA 24/7</strong> para acompañarte en tres rutas: empleabilidad, emprendimiento y crecimiento empresarial.
          </p>
        </div>
      </div>

      {/* CTAs */}
      <div className="uc__cta">
        <Link to="/" className="uc__cta-btn uc__cta-btn--primary">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
          </svg>
          Volver al Inicio
        </Link>
        <Link to="/plans/" className="uc__cta-btn uc__cta-btn--secondary">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
            <line x1="3" y1="9" x2="21" y2="9"></line>
            <line x1="3" y1="15" x2="21" y2="15"></line>
            <line x1="9" y1="3" x2="9" y2="21"></line>
            <line x1="15" y1="3" x2="15" y2="21"></line>
          </svg>
          Modelo de Negocios
        </Link>
        <a
          href="https://comunidad.wirkconsulting.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="uc__cta-btn uc__cta-btn--outline"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path>
            <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>
          </svg>
          Explorar Formación
        </a>
      </div>

      <div className="uc__footer-note">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
          <polyline points="22,6 12,13 2,6"></polyline>
        </svg>
        Te notificaremos por correo electrónico tan pronto como los asistentes IA estén disponibles para tu ruta.
      </div>
    </>
  );
};

export default ConstructionContent;
